import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/LockUnlocked.svg'

export const IconLockUnlocked = IconSVG as IconComponent
